import { capitalize } from 'lodash'
import { SuggestedCategoriesGroup } from './SuggestedCategoriesGroup'
import { UnsplashSuggestedCategory } from './SuggestedCategory/UnsplashSuggestedCategory'
import { Preview } from './SuggestedCategory/Types'

interface Props {
  onExpand: (query: string, seeds?: Preview[]) => void
}
const GROUPS: Array<{ name: string; subGroups: Array<{ query: string; seeds?: Array<Preview> }> }> = [
  {
    name: 'Textures',
    subGroups: [
      {
        query: 'wood',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025154/blaze_assets/designer/backgrounds/3_ecomm/4_wood/Wood-Texture-02_euyatl.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025153/blaze_assets/designer/backgrounds/3_ecomm/4_wood/Wood-Texture-03_qbkoxa.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025152/blaze_assets/designer/backgrounds/3_ecomm/4_wood/Wood-Texture-01_fty5hl.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025143/blaze_assets/designer/backgrounds/3_ecomm/4_wood/Remove_Objects_Style_elifzk.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025131/blaze_assets/designer/backgrounds/3_ecomm/4_wood/Remove_Objects_Style_Raw_napglc.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'marble',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025132/blaze_assets/designer/backgrounds/3_ecomm/3_marble/Stone-Texture-04_zxax7z.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025131/blaze_assets/designer/backgrounds/3_ecomm/3_marble/Marble-Texture-01_iccobc.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025127/blaze_assets/designer/backgrounds/3_ecomm/3_marble/Stone-Texture-03_rf0pg0.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025118/blaze_assets/designer/backgrounds/3_ecomm/3_marble/Stone-Texture-02_mi1a2l.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025105/blaze_assets/designer/backgrounds/3_ecomm/3_marble/Stone-Texture-05_hlxvva.jpg',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'concrete',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025131/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Concrete-Texture-03_uv4e0v.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025102/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Joel_style_raw_wczwkd.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025100/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Concrete-Texture-01_yy8k5i.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025095/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Remove_Objects_Style_Raw_1_uyhpjy.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025085/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Joel_style_raw_copy_f5d213.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025084/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Remove_Objects_Style_1_kxd8pl.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025083/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Joel_style_raw_2_msdpg1.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025080/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Remove_Objects_Style_2_qj0buf.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025070/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Concrete-Texture-02_cjsaay.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025070/blaze_assets/designer/backgrounds/3_ecomm/1_concrete/Joel_style_raw_1_d1zye3.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'flatlays',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025182/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/My_Images_Joel_Style_ucqi5u.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025182/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/Joel_remove_style_zyzp7f.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025179/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/My_Images_eeec689f_qaximo.png',
            width: 1080,
            height: 1434,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025178/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/Joel_raw_image_eagqrs.png',
            width: 1080,
            height: 1434,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025174/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/Flat-Lay-Product-Shot-_2_nsfkmr.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025172/blaze_assets/designer/backgrounds/3_ecomm/2_flatlays/Flat_Lay_Product_Shot_btmync.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
    ],
  },
  {
    name: 'Scenes',
    subGroups: [
      {
        query: 'podiums',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025153/blaze_assets/designer/backgrounds/3_ecomm/6_simple_fashion/Simple_Fashion_2_vl7yyj.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025153/blaze_assets/designer/backgrounds/3_ecomm/6_simple_fashion/Simple_Fashion_1_ln7iep.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025152/blaze_assets/designer/backgrounds/3_ecomm/6_simple_fashion/Simple_Fashion_3_gv36ui.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025147/blaze_assets/designer/backgrounds/3_ecomm/6_simple_fashion/Simple_Fashion_5_e9wkeg.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025142/blaze_assets/designer/backgrounds/3_ecomm/6_simple_fashion/Simple_Fashion_4_t9b5yc.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'nature',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036186/blaze_assets/designer/backgrounds/4_verticals/5_nature/Modern_creative_product_photo_5_yjtwbh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036185/blaze_assets/designer/backgrounds/4_verticals/5_nature/Remove_Objects_2_zsybfn.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036175/blaze_assets/designer/backgrounds/4_verticals/5_nature/Remove_Object_cluspk.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036175/blaze_assets/designer/backgrounds/4_verticals/5_nature/Remove_Objects_1_d3ovq0.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036170/blaze_assets/designer/backgrounds/4_verticals/5_nature/Modern_creative_product_photo_4_aeennt.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036170/blaze_assets/designer/backgrounds/4_verticals/5_nature/Joel_remove_te34zg.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036150/blaze_assets/designer/backgrounds/4_verticals/5_nature/Modern_creative_product_photo_6_x86hsb.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036150/blaze_assets/designer/backgrounds/4_verticals/5_nature/Joel_Image_xvloxx.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036149/blaze_assets/designer/backgrounds/4_verticals/5_nature/Remove_Objects_luc4rl.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'cosmetics',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036152/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Joel_style_raw_c56zwi.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036152/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Cosmetic_Product_on_Tile_3_bi25tg.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036135/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Modern_creative_product_photo_3_ygzrgv.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036134/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Cosmetic_product_on_tile_2_wfbfsx.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036130/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Modern_creative_product_photo_2_etrua2.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036130/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Simple_product_photo_2_akb7ne.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036123/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Makeup_product_photo_ozxqpv.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036123/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Remove_Objects_Style_Raw_4_znyahh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036123/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Cosmetic_Product_on_Tile_5_ftuiq4.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036102/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Simple_product_photo_cj0m4h.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036102/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Modern_creative_product_photo_1_n3ie5n.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036100/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Simple_product_photo_1_ojn2rs.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036099/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Cosmetic_product_on_tile_1_cxemwu.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036077/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Remove_Objects_Style_3_zy1exm.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036076/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Remove_Objects_Style_Raw_3_ua9ehs.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036069/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Cosmetic_product_on_tile_y0s3xf.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036068/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Modern_product_photo_1_t77iew.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036068/blaze_assets/designer/backgrounds/4_verticals/1_cosmetics/Simple_graphic_for_moisturizer_s6cp8z.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'studio',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025171/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_5_dblnzm.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025170/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Seamless-Product-Shot-3_qyuycx.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025170/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Seamless-Product-Shot-1_anppos.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025169/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_4_ryy1vx.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025169/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Seamless-Product-Shot-2_cs4htl.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025169/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Seamless-Product-Shot-5_dqngll.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025169/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Seamless-Product-Shot-4_scvxkt.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025168/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace-10_etwudn.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025167/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace-9_xnzyw4.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025167/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Outfit-Woman-Full-Body-Shot-_5_d7rtgj.jpg',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025166/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Remove_Object_Style_g0lzfg.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025165/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_2_guwrxw.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025163/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_6_sxjfyb.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025159/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_3_hfiugd.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025158/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_7_arfzhz.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720025155/blaze_assets/designer/backgrounds/3_ecomm/7_marketplace/Marketplace_1_vxvnak.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'drinks',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036235/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_Mango_Slices_and_Black_Berries_nevjry.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036215/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_lime_slices_and_cherries_agx2pz.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036215/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_Orange_Slices_and_Blueberries_sqe54k.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036210/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Drink_with_Orange_Slices_xs1mqv.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036208/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_Mint_and_Raspberries_qet3ck.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036208/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_Mango_Slices_and_Black_Berries_1_n6dyvb.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036195/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Drink_with_Lime_and_Cherries_1_sukwmh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036195/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Floating_Orange_Slices_Blueberries_zbxk7t.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036194/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Drink_with_Lime_and_Cherries_aeegaj.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036185/blaze_assets/designer/backgrounds/4_verticals/2_drinks/Drink_with_Mint_and_Raspberries_c1cnfp.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'food',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036322/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_Studio_Photoshoot_bjxxsi.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036316/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_Photoshoot_Midjourney_luonib.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036312/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_Studio_Photoshoot_2_u6lqm4.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036309/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_Studio_Shoot_lgx5ba.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036306/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_Studio_Photoshoot_1_ddscx9.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036300/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_counter_food_commercial_1_hjauch.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036297/blaze_assets/designer/backgrounds/4_verticals/3_food/Kitchen_counter_food_commercial_vagxld.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'kids',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036287/blaze_assets/designer/backgrounds/4_verticals/4_kids/Children_Product_Graphic_mfog8w.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036285/blaze_assets/designer/backgrounds/4_verticals/4_kids/Watercolor_Stroke_Graphic_xpunsr.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036282/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_product_graphic_sci9is.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036281/blaze_assets/designer/backgrounds/4_verticals/4_kids/Product_Watercolor_Graphic_1_pxeezn.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036278/blaze_assets/designer/backgrounds/4_verticals/4_kids/Product_watercolor_graphic_hxi63q.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036276/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_product_graphic_watercolor_1_xfsnsd.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036276/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_children_graphic_2_lmqld4.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036269/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_product_graphic_1_nwc1ny.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036266/blaze_assets/designer/backgrounds/4_verticals/4_kids/Product_graphic_shape_bskwpj.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036263/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_graphic_for_children_3_lebxrd.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036261/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_graphic_for_children_2_yv2fdq.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036259/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_product_graphic_2_hhpuxm.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036258/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_product_graphic_watercolor_qughs7.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036257/blaze_assets/designer/backgrounds/4_verticals/4_kids/Product_watercolor_stroke_rttt1l.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036254/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_graphic_for_children_x8xbsh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036248/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_graphic_for_children_1_zjq4yg.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036247/blaze_assets/designer/backgrounds/4_verticals/4_kids/Photo_from_the_floor_l888h6.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036242/blaze_assets/designer/backgrounds/4_verticals/4_kids/Dress_Top_Photo_c2lkzh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036242/blaze_assets/designer/backgrounds/4_verticals/4_kids/Dress_Top_Photo_c2lkzh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036227/blaze_assets/designer/backgrounds/4_verticals/4_kids/Product_Watercolor_Stroke_1_mabkfb.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036225/blaze_assets/designer/backgrounds/4_verticals/4_kids/Simple_Children_Graphic_biyand.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
      {
        query: 'sports',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036068/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_kooo4f.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036067/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_5_wudxbx.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036064/blaze_assets/designer/backgrounds/4_verticals/7_sports/Modern_creative_product_photo_9_ho8xbe.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036063/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_4_slklpx.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036055/blaze_assets/designer/backgrounds/4_verticals/7_sports/Modern_creative_product_photo_8_bmfugq.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036051/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_set_photo_hcouub.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036048/blaze_assets/designer/backgrounds/4_verticals/7_sports/Modern_Creative_Product_Photo_7_ncxojj.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036046/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_2_gdpfln.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036042/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_1_tquvmj.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036038/blaze_assets/designer/backgrounds/4_verticals/7_sports/Modern_creative_product_photo_1_eruvuo.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036036/blaze_assets/designer/backgrounds/4_verticals/7_sports/Modern_creative_product_photo_2_msa4zd.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036024/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_6_dr1o2r.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036022/blaze_assets/designer/backgrounds/4_verticals/7_sports/Nike_shoe_product_photo_10_lox9t7.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
    ],
  },
  {
    name: 'Places',
    subGroups: [
      {
        query: 'vacation',
        seeds: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036026/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_11_duvz9o.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036025/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_10_ulee8l.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036019/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_4_yvzvyh.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036006/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_5_btodbk.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036006/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_1_tcgib9.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720036006/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_13_vznefo.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035999/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_12_hxdtze.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035990/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_7_jnqyvo.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035986/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_6_wy5slo.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035973/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_9_lflojf.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035971/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_8_pdcs99.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035960/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_2_gb713t.png',
            width: 1080,
            height: 1080,
          },
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/q_auto,c_scale,w_1080/v1720035954/blaze_assets/designer/backgrounds/4_verticals/8_vacation/Vacation_Destination_Landscape_3_vrkahk.png',
            width: 1080,
            height: 1080,
          },
        ],
      },
    ],
  },
  {
    name: 'Nature',
    subGroups: [{ query: 'mountains' }, { query: 'beach' }, { query: 'forest' }, { query: 'flowers' }],
  },
  {
    name: 'People',
    subGroups: [{ query: 'portraits' }, { query: 'fashion' }, { query: 'lifestyle' }, { query: 'family' }],
  },
  { name: 'Animals', subGroups: [{ query: 'dogs' }, { query: 'cats' }, { query: 'wildlife' }, { query: 'birds' }] },
]

export const Suggestions = ({ onExpand }: Props) => (
  <>
    {GROUPS.map(({ name, subGroups }) => (
      <SuggestedCategoriesGroup key={name} name={name}>
        {subGroups.map(({ query, seeds }) => (
          <UnsplashSuggestedCategory key={query} name={capitalize(query)} onExpand={onExpand} seeds={seeds} />
        ))}
      </SuggestedCategoriesGroup>
    ))}
  </>
)
